import { Component } from '@angular/core';
import { Platform } from '@ionic/angular';
import { forkJoin, Subscription } from 'rxjs';
import { take } from 'rxjs/operators';

import { AccountBalanceService } from 'src/app/services/balance/account-balance.service';
import { CashierContentService } from 'src/app/services/cashier/cashier-content.service';
import { CommonAlertService } from 'src/app/services/alert/alert.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { DailySpinService } from 'src/app/services/daily-spin/daily-spin.service';
import { DeeplinkRedirectService } from 'src/app/services/deeplink-redirect/deeplink-redirect.service';
import { EventsService } from 'src/app/services/event/event.service';
import { GameHubControllerService } from 'src/app/services/gameHub/game-hub-controller';
import { GameTileService } from 'src/app/services/game-tile/game-tile.service';
import { GeoResponse } from 'src/app/interfaces/geo-interface';
import { isUndefined, removeSpace, toBoolean } from 'src/app/services/codeUtils';
import { JurisdictionService } from 'src/app/services/geo/jurisdiction.service';
import { LocationWarningService } from 'src/app/services/location-warning/location-warning.service';
import { LoginService } from 'src/app/services/login/login.service';
import { LogoutService } from 'src/app/services/logout/logout.service';
import { MobileToolsService } from 'src/app/services/mobile-tools/mobile-tools.service';
import { Navigator } from 'src/app/services/routing/navigator';
import { ResponsibleGamingService } from 'src/app/services/responsible-gaming-service/responsible-gaming.service';
import { UserSessionService } from 'src/app/services/user-session/user-session.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { WithdrawalService } from 'src/app/services/cashier/withdrawal.service';
import { GeoLocationStrategyService } from 'src/app/services/geo-location-strategy/geo-location-strategy.service';
import { GeoLocationControllerService } from 'src/app/services/geo-location/geo-location-controller.service';

@Component({
	selector: 'app-init',
	standalone: true
})

export class AppInitComponent {

	private initTriggeredBy;
	private _Que = [];
	public depositCode = '';
	public optInId = null;
	public initTime = 0;
	public customer;
	public accountBalances: any;
	public customerQualification: any;
	public geolocationPasses: boolean;
	public loading;
	public appInitNextEvent: Subscription;
	public wlAgreed: boolean;
	public reconfirmPersonalDetails: boolean;
	public dailySpinData: any;

	constructor(
		private accountBalanceService: AccountBalanceService,
		private cashierContentService: CashierContentService,
		private commonAlertService: CommonAlertService,
		private configService: ConfigService,
		private dailySpinService: DailySpinService,
		private deeplinkRedirectService: DeeplinkRedirectService,
		private eventsService: EventsService,
		private gameHubControllerService: GameHubControllerService,
		private gameTile: GameTileService,
		private jurisdiction: JurisdictionService,
		private locationWarningService: LocationWarningService,
		private loginService: LoginService,
		private logoutService: LogoutService,
		private mobileToolsService: MobileToolsService,
		private navigator: Navigator,
		private platform: Platform,
		private responsibleGamingProvider: ResponsibleGamingService,
		private geoLocationControllerService: GeoLocationControllerService,
		private geoLocationStrategyService: GeoLocationStrategyService,
		private userSessionService: UserSessionService,
		private utilsService: UtilsService,
		private withdrawService: WithdrawalService,
	) {
		if (this.platform.is("capacitor")) {
			this.mobileSetup();
		}
		this.eventsService.subscribe('event:appInit:init', (params) => {
			this.initTriggeredBy = !!params && !!params.triggeredBy ? params.triggeredBy : '';

			this.depositCode = !!params && !!params.depositCode ? params.depositCode : '';
			if (!this.initTime) {
				this.initTime++;
				setTimeout(() => this.init(), 60);
			}
		});

		this.eventsService.subscribe("event:authentication:logout", () => {
			this.eventsService.unsubscribe("event:appInit:next");
			this.initTime = 0;
			this._Que = [];
		})

		if (this.platform.is("capacitor") && this.platform.is("android")) {
			this.platform.backButton.subscribeWithPriority(100, () => {
				this.navigator.goBackOrExitApp();
			});
		}
	}

	init() {
		forkJoin([
			this.userSessionService.getCustomer().pipe(take(1)),
			this.accountBalanceService.getBalance().pipe(take(2)),
			this.accountBalanceService.callGetQualification('freespin').pipe(take(1)),
			// this.dailySpinService.getDailyBonus().pipe(take(1)),
		]).subscribe(([customer, balance, customerQualification]) => {
			this.customer = customer;
			this.accountBalances = balance;
			this.customerQualification = customerQualification;
			this.setTheRulesAndStart();
			this.geolocationPasses = false;
			// this.dailySpinData = dailySpinData;
		});

		this.appInitNextEvent = this.eventsService.subscribe('event:appInit:next', (data) => {
			if (!isUndefined(data) && data && !isUndefined(data.geolocationPasses)) {
				this.geolocationPasses = data.geolocationPasses;
			}
			this.popQueAndNext("event:appInit:next")
		}
		);

		this.accountBalanceService.updateBalance();
		this.withdrawService.callGetPayoutMethods();
	}

	mobileSetup() {
		setTimeout(() => {
			this.deeplinkRedirectService.deeplinksListener();
		}, 1000);
		this.mobileToolsService.checkForUpdate();
		if (this.platform.is("android")) {
			this.androidSetup();
		}
	}

	androidSetup() {
		const locationWarningCheck = this.configService.getConfig().FEATURE_LOCATION_WARNING_CHECK === "1" ? true : false;
		if (locationWarningCheck) {
			this.locationWarningService.initGeoVerificationProcess();
		} else {
			this.mobileToolsService.requestAndroidGeoPermissions();
		}

		this.mobileToolsService.checkRestrictedPlayStore().then(() => {
			console.log("show play store restricted?", this.mobileToolsService.shouldRestrictPlayStore)
			if (!this.mobileToolsService.shouldRestrictPlayStore) {
				this.mobileToolsService.checkForUpdate().then(() => {
					console.log("show update?", this.mobileToolsService.shouldUpdate)
				})
			}
		})
	}
	protected setTheRulesAndStart(): any {
		const rules = this.rules();

		if (rules.customerCoolingOff()) this.addCoolOffAction();
		if (rules.migratedPlayer()) this.addMigration();
		if (rules.customerIncomplete()) this.addSignupStepTwo();
		if (rules.customerKYCFail()) this.addKYCInvalid();
		if (rules.customerLoginEligiblityCheck()) this.askForEligibility();
		if (rules.hasAvailableFreeSpins()) this.addFreeSpins();

		if (this.initTriggeredBy == "REFRESH") {
			if (rules.customerMFA() == 'true') this.addMFA();
			if (rules.customerStrongAuthRequiredCheck() == 'true') this.addStrongAuthentication();
		}

		if (this.initTriggeredBy !== 'REFRESH' || location.hash == '#launchDS') {
			if (location.hash == '#launchDS') {
				this.utilsService.removeUrlParams();
			}
		}
		const config = this.configService.getConfig();
		const geoAfterLoginFlag: boolean = this.configService.isFeatureON(config, 'FEATURE_GEOLOCATION_ENFORCED_ON_LOGIN', false);
		const geoAfterRefreshFlag: boolean = this.configService.isFeatureON(config, 'FEATURE_GEOLOCATION_ENFORCED_ON_REFRESH', false);

		this.showLobby();
		if (!rules.customerNotActive() && this.initTriggeredBy !== 'REFRESH') {
			if (this.configService.getConfig().FEATURE_SHOW_LIMITS_ON_LOGIN === '1') this.addCheckPendingLimit();

			//W2G
			const w2GPopupEnabled: boolean = toBoolean(this.configService?.getConfig()?.FEATURE_W2G_TAX_POPUP_ENABLED) ?? false;
			if ((null === this.customer.getCustomDataProperty('W2G_ELECTRONIC_MAIL_CONSENT')
				|| undefined === this.customer.getCustomDataProperty('W2G_ELECTRONIC_MAIL_CONSENT'))
				&& w2GPopupEnabled && this.customer.status.toLowerCase() === "active") { //&& !rules.noAckRegulations() mabyber will be needed to add in future
				this.callW2GPopup();
			}


			if (this.configService.getConfig().FEATURE_SHOW_WIN_LOSS_ON_LOGIN === '1') this.addWinLossPopup();
			// Add GeoComply Verification on Login.
			if (geoAfterLoginFlag && !rules.customerNotActive()) {
				this.addGeoComplyVerification();
			}
		}


		// Check Geo Location on Refresh with config check
		if (geoAfterRefreshFlag && !rules.customerNotActive() && this.initTriggeredBy === 'REFRESH') {
			this.addGeoComplyVerification();
		}
		if (this.configService.getConfig().FEATURE_CUSTOMER_RECONFIRM === '1') {
			if (rules.customerAnnualReconfirmationCheck()) {
				this.addPersonalReconfirmation();
			}
		}

		if (rules.customerLoginShowPlayerDashboard()) this.addShowPlayerDashboard();

		this.addLobbyCheckForNotificationLoop();
		if (rules.registrationLoginWithADepositCode()) this.addRedirectToDepositPage();
		if (rules.waitingToLaunchAGame()) this.addLaunchGame();
		if (rules.waitingToOpenModal()) this.openModalWindow();
		if (rules.registrationLoginWithAnOffer()) this.optInToOffer();

		this.addNotifications(rules.customerLoginShowPlayerDashboard());

		this._Que.reverse();
		this.next();
	}

	addStrongAuthentication() {
		this._Que.push({
			name: "Strong Auth",
			action: () => {
				this.navigator.navigateTo("PinLoginComponent", { forceModal: true }, { customerId: this.customer.customerId, callBackFn: () => { this._Que.pop(); this.next() } })
			}
		})
	}


	rules() {

		let isQualified = () => {
			let data = this.customerQualification.payload;
			let pageToNavigate;

			let response: any = {
				result: true,
				pageToNavigate: pageToNavigate,
			};

			if (!!data) {
				switch (data['policy-name']) {
					case 'emailvalidation':
						pageToNavigate = 'InvalidEmailComponent';
						break;
					case 'geolocation':
						pageToNavigate = 'InvalidGeoComponent';
						break;
					case 'kyc':
						pageToNavigate = 'InvalidKycComponent';
						break;
					case 'spincriteria':
						pageToNavigate = 'InvalidSpinPage';
						break;
					case 'geocomply':
						pageToNavigate = 'GeoComplyComponent';
						break;
				}
				response = {
					result: false,
					pageToNavigate: pageToNavigate,
				};
			}
			return response;
		};

		let customerIsActive = () => {
			return (this.customer.status.toLowerCase() === "active") ? true : false;
		}

		let customerNotActive = () => {
			return this.customer.status.toLowerCase() === 'active' ? false : true;
		};

		let customerIncomplete = () => {
			return this.customer.status.toLowerCase() === 'incomplete' ? true : false;
		};

		let customerKYCFail = () => {
			return this.customer.status.toLowerCase() === 'kyc_fail' ? true : false;
		};

		let customerCoolingOff = () => {
			return ('status' in this.customer && this.customer.status == 'SELF_EXCLUDED_COOL_OFF');
		};

		let customerMFA = () => {
			let mfa = localStorage.getItem('userSession.mfa');
			return mfa;
		}

		let customerStrongAuthRequiredCheck = () => {
			return localStorage.getItem('strongAuthenticationRequired');
		}
		let migratedPlayer = () => {
			const incompletePlayer: boolean = customerIncomplete();
			return !!this.customer && incompletePlayer && (this.customer.getCustomDataProperty('CRE_BY') === 'MIGRATION' || this.customer.getCustomDataProperty('CRE_BY') === 'PA_MIGRATION');
		}

		// if MFREESPIN > 0 && is not a new customer
		let hasDailySlot = () => {
			let availableSpins = 'undefined' !== typeof this.accountBalances.MFREESPIN ? this.accountBalances.MFREESPIN.availableBalance : false;
			let customerData: Array<any> = !!this.customer ? this.customer.customData : [];
			let newAccountValue = customerData.filter((x) => { return x.key === 'NEW_ACCOUNT_TASKS'; }).map((x) => x.value).reduce((value) => value, 0);
			let isNewCustomer = <string>newAccountValue === '1' ? true : false;
			let slotEnabled = this.configService.getConfig().SITE_HAS_DAILY_SLOT === '1' ? true : false;
			return availableSpins && !isNewCustomer && slotEnabled ? availableSpins : false;
		};

		let hasValidEmail = () => {
			return !!this.customer && !isUndefined(this.customer.emailValidated) && this.customer.emailValidated ? true : false;
		};

		let registrationLoginWithADepositCode = () => {
			return !!this.depositCode ? true : false;
		};

		let waitingToLaunchAGame = () => {
			return !!this.gameTile.waitingGameData;
		};

		let waitingToOpenModal = () => {
			return this.navigator.getWaitingModal() !== null ? true : false;
		};

		let shouldLoadGeocomply = () => {
			let hash = document.location.hash.split('&').shift();
			let hashes = [
				'#show-page',
				'#paypal',
				'#paypal-funded',
				'#paypad-nonfunded',
				'#password_reset',
				'#interac-return'
			];
			return !(hash && hash !== '' && hashes.indexOf(hash) > -1);
		};

		let isSportsApp = () => {
			return this.configService.isSportsApp();
		};

		let hasAvailableFreeSpins = () => {
			const hasAvailableFreeSpinsFlag: boolean = toBoolean(this.configService.getConfig().FEATURE_SHOW_FREESPINS_ON_LAUNCH) ?? false;
			return hasAvailableFreeSpinsFlag && this.dailySpinService.getDailyBonus();
		};

		let registrationLoginWithAnOffer = () => {
			return !!this.optInId ? true : false;
		};

		let customerAnnualReconfirmationCheck = () => {
			if (this.configService.getConfig().FEATURE_CUSTOMER_RECONFIRM === '1') {
				this.reconfirmPersonalDetails = localStorage.getItem("reconfirmPersonalDetails") !== null;
			}
			return this.reconfirmPersonalDetails;
		}

		let customerLoginEligiblityCheck = () => {
			return this.loginService.checkForEligibility()
		};

		const customerLoginShowPlayerDashboard = () => {
			const customerShowDashboard = !this.customer.customData.find(item => item.key === 'SHOW_DASHBOARD') || this.customer.customData.find(item => item.key === 'SHOW_DASHBOARD' && item.value === 'true');
			const customerCompleted = customerIsActive();

			return this.initTriggeredBy === 'LOGIN' && customerCompleted && customerShowDashboard;
		}

		return {
			customerCoolingOff,
			customerIncomplete,
			customerKYCFail,
			customerMFA,
			customerNotActive,
			customerIsActive,
			hasAvailableFreeSpins,
			hasDailySlot,
			hasValidEmail,
			isQualified,
			isSportsApp,
			migratedPlayer,
			registrationLoginWithADepositCode,
			customerStrongAuthRequiredCheck,
			registrationLoginWithAnOffer,
			shouldLoadGeocomply,
			waitingToLaunchAGame,
			waitingToOpenModal,
			customerLoginEligiblityCheck,
			customerAnnualReconfirmationCheck,
			customerLoginShowPlayerDashboard,
		};
	}


	addCoolOffAction() {
		this._Que.push({
			name: 'Customer Cool Off',
			action: () => {
				this.navigator.navigateTo('CoolingOffComponent', { forceModal: true });
			},
		});
	}

	addSignupStepTwo() {
		this._Que.push({
			name: 'Signup step 2',
			action: () => {
				this.navigator.navigateTo('SignupStepTwoComponent', { forceModal: true });
			},
		});
	}

	addMigration() {
		this._Que.push({
			name: "Customer Migration Check",
			action: () => {
				const playerMigrationPageEnabled: boolean = this.configService.getConfig().FEATURE_PLAYER_MIGRATION_WP_ENABLED ?? true;
				playerMigrationPageEnabled ?
					this.navigator.navigateTo("PlayerMigrationComponent", { forceModal: true }) :
					this.navigator.navigateTo('PlayerMigrationActionComponent', { forceModal: true });
			}
		})
	}

	addKYCInvalid() {
		this._Que.push({
			name: 'Invalid Kyc',
			action: () => {

				let kyc_step = this.customer.getCustomDataProperty('KYC_STEP');
				if (this.customer.getCustomDataProperty('IS_PEP_OR_HIO') === 'true') {
					this.commonAlertService.showPepHioAlert(undefined, this.closeModal());
					// check config if we go to CAMS Idology
				} else if (!isUndefined(this.configService.getConfig().FEATURE_IS_IDOLOGY)) {
					//canada - we don't set governmentTypeId
					switch (kyc_step.toUpperCase()) {
						case 'PENDING_RETRY':
							this.navigator.navigateTo("CamsComponent");
							break;
						case 'PENDING_IDSCAN':
							this.navigator.navigateTo("CamsComponent");
							break;
						case "DONE":
							setTimeout(() => { this._Que.pop(); this.next() }, 500);
							break;
						default:
							this.navigator.navigateTo("CamsComponent");
							break;
					}
				} else if (isUndefined(this.customer.kyc_attempts)) {
					this.navigator.navigateTo('InvalidKycComponent', {}, { allAttemptsUsed: true });
				} else {
					let attempts = this.configService.getConfig().FEATURE_KYC_MAX_ATTEMPTS || 3;
					if (this.customer.kyc_attempts < attempts) {
						this.navigator.navigateTo('InvalidKycComponent');
					} else if (this.customer.kyc_attempts >= attempts) {
						this.navigator.navigateTo('InvalidKycComponent', {}, { allAttemptsUsed: true });
					}
				}
			},
		});
	}

	askForEligibility() {
		this._Que.push(({
			name: "Face ID eligibility",
			action: () => {
				this.loginService.showEligibility();
			}
		}))
	}

	addFreeSpins() {
		this._Que.push({
			name: "Free Daily spin",
			action: () => {
				this.dailySpinService.initDailyBonusGame().then(
					result => {
						if (!!result) this.gameHubControllerService.launchDailySpin(1);
					}
				)
			}
		})
	}

	closeModal = () => {
		this.navigator.dismissAll();
		this.logoutService.onLogout({ reason: 'QUALIFICATION_KYC_FAIL' });
	};

	addMFA = () => {
		this._Que.push({
			name: "MFA",
			action: () => {
				let isSMS_OR_EMAIL = this.configService.getConfig().FEATURE_MFA_TYPE ? this.configService.getConfig().FEATURE_MFA_TYPE : 'SMS';
				if (null !== this.customer.getCustomDataProperty("MFA_METHOD")) {
					if (this.customer.getCustomDataProperty("MFA_METHOD") === 'SMS') {
						return this.navigator.navigateTo("SmsLoginComponent", { forceModal: true }, { customerId: this.customer.customerId, callBackFn: () => { this.popQueAndNext("SmsLoginComponent") } })
					} else {
						return this.navigator.navigateTo("AuthenticatorAppLoginComponent", { forceModal: true }, { customerId: this.customer.customerId, callBackFn: () => { this.popQueAndNext("SmsLoginComponent") } })
					}
				} else {
					if (isSMS_OR_EMAIL == 'SMS') return this.navigator.navigateTo("SmsLoginComponent", { forceModal: true }, { customerId: this.customer.customerId, callBackFn: () => { this.popQueAndNext("SmsLoginComponent") } })

					return this.navigator.navigateTo("CodeLoginPage", { forceModal: true }, { customerId: this.customer.customerId, callBackFn: () => { this.popQueAndNext("CodeLoginPage") } })
				}


			}
		})
	}

	showLobby() {
		this._Que.push({
			name: "Show Lobby",
			action: () => {
				this.eventsService.publish("event:lobby:show");
				this._Que.pop();
				this.next();
			}
		})
	}


	addCheckPendingLimit = () => {
		this._Que.push({
			name: 'Check Pending Limit Verification',
			action: () => {
				this.responsibleGamingProvider.getAllPendingLimit().subscribe(
					(response: any) => {
						if (response && !!response.result && !!response.payload) {
							if (response.payload.length !== 0) {
								this.navigator.navigateTo('LimitConfirmationComponent', { forceModal: true }, {
									callBackFn: () => { this.popQueAndNext("LimitConfirmationComponent callbk") },
									data: response.payload
								});
							} else {
								this.popQueAndNext("LimitConfirmationComponent else")
								console.log('No Pending Limit for User')
							}
						}
					},
					(error) => {
						this.popQueAndNext("LimitConfirmationComponent else")
					}
				);
			},
		});

	}

	addWinLossPopup = () => {

		this._Que.push({
			name: 'Win Loss Popup',
			action: () => {
				let data = {
					title: "Win/Loss",
					message: "You may check your wins/losses for the current session or for previous sessions.",
					linkText: "Go to my wins/losses report.",
					confirmLink: () => {
						this.wlAgreed = true;
						// this._Que.pop(); this.next();
					},
					decline: () => {
						// this._Que.pop(); this.next();
					}
				};

				let wlPpopupPromise = this.navigator.openPopover(
					"PopoverStandardConfirmComponent",
					{ message: data }, "standard-popover",
					true, true, true, -1, 'cover', true
				);
				wlPpopupPromise.then(p => {
					p.onDidDismiss().then(() => {
						this.popQueAndNext("Win Loss Popup")
					})
				})
			},
		});
	}



	addGeoComplyVerification = () => {
		this._Que.push({
			name: 'GeoComply Verification',
			action: () => {
				if (this.geoLocationStrategyService.isGeoOptimizationEnabled()) {
					// Use the optimized geolocation method
					this.geoLocationControllerService.executeGeoLocationProcess()
						.then((geoResp: GeoResponse) => {
							console.log(geoResp);
							this.popQueAndNext("GeoComply Verification");
						})
						.catch(() => {
							this.popQueAndNext("GeoComply Error");
						});
				} else {
				this.jurisdiction
					.debounceVerifyJurisdiction(() => { })
					.then((geoResp: GeoResponse) => {
						if (this.wlAgreed) {
							this.goToWinLoss();
						}
						this.popQueAndNext("GeoComply Verification")
					})
					.catch((err) => {
						this.popQueAndNext("GeoComply Error")
					});
				}

			},
		});

	}

	goToWinLoss = () => {
		this.navigator.navigateTo("WinLossComponent", { forceModal: true }, { callBackFn: () => { this.popQueAndNext("WinLossComponent") } });
	}



	addLobbyCheckForNotificationLoop() {
		this._Que.push({
			name: 'Notification listener on lobby',
			action: () => {
				if (this.loading) this.loading.dismiss();
				this.eventsService.publish('event:lobby:checkMarketingNotification');
				setTimeout(() => {
					this.popQueAndNext("Notification listener on lobby")
				}, 3000);
			},
		});
	}

	addRedirectToDepositPage() {
		this._Que.push({
			name: 'Navigate to Deposit page with code.',
			action: () => {
				this.navigator.navigateTo('DepositMainComponent', { forceModal: true }, { depositCode: this.depositCode });
			},
		});
	}

	addPersonalReconfirmation() {
		this._Que.push({
			name: 'Annual Personal Reconfirmation',
			action: () => {
				this.navigator.openPopover('PopoverReconfirmation', {}, 'standard-popover reconfirm', false, true, true, -1, 'cover', true);

			},
		});
	}

	addLaunchGame() {
		this._Que.push({
			name: 'Launch a game',
			action: () => {
				const gameData = this.gameTile?.waitingGameData;
				if (!!gameData) {
					this.gameHubControllerService.launchCasinoGame(gameData);
				}
			},
		});
	}

	addTestPopup() {
		this._Que.push({
			name: 'Add test pop',
			action: () => {
				this.navigator.navigateTo('PlayerMigrationActionComponent', { forceModal: true }, { status: false });
			},
		});
	}

	addNotifications(playerDashboardShown: boolean) {
		this._Que.push({
			name: "Notification Listener",
			action: () => {
				if (this.loading) this.loading.dismiss();
				this.eventsService.publish("event:notifications:start", { skipMarketingNotificationsOnLogin: playerDashboardShown });
			}
		})
	}

	openModalWindow() {
		this._Que.push({
			name: 'Open Modal Window',
			action: () => {
				const modal = this.navigator.getWaitingModal();
				const param = this.navigator.getWaitingModalParams();
				if (modal?.slice(0, 5) == 'CCNP_') return this.onContentPlaceholder(modal);
				this.navigator.setWaitingModal(null, null);
				if (!!modal && modal == 'LoginComponent') return;
				if (!!modal && !!param && modal == 'DepositMainComponent') {
					if (param?.depositcode) {
						this.cashierContentService.updateBonusOfferValue(param.depositcode);
					}
					return this.navigator.navigateTo(modal, { multipleModals: true }, param);
				}
				if (!!modal) return this.navigator.navigateTo(modal);
			},
		});
	}

	optInToOffer() {
		this._Que.push({
			name: 'Opt-In to offer.',
			action: () => {
				let link = this.configService.getExternalLinks().payload.find((link) => link.code == this.optInId);
				this.eventsService.publish('event:webview:load', link.url);
			},
		});
	}

	private onContentPlaceholder(pageName?: string) {
		const link: string = pageName?.replace("CCNP_", "");
		const cleanedLink = removeSpace(link);
		return this.navigator.navigateTo('ContentPlaceholderComponent', { multipleModals: true }, { link: cleanedLink });
	}

	next() {
		if (!this.userSessionService.isAuthenticated()) return;

		if (this._Que.length) {
			const next = this._Que[this._Que.length - 1];
			if (!isUndefined(next) && 'action' in next) {
				next.action();
			}
		} else {
			this.onFinish();
		}
	}

	onFinish() {
		if (this.loading) this.loading.dismiss();
		this.appInitNextEvent.unsubscribe();
		//this.navigator.dismissAll();
	}

	popQueAndNext(name) {
		const action = name ?? "no name";
		console.log("App Init call next: ", action)
		this._Que.pop();
		this.next();
	}

	callW2GPopup() {

		this._Que.push({
			name: "App Init - Open W2G",
			action: () => {
				const data = { title: 'W2G TAX' };
				this.navigator.openPopover('W2GPopover', data, 'standard-popover', false).then((result) => {
					result.onDidDismiss().then(p => {
						setTimeout(
							() => {
								this._Que.pop(); this.next();
							}
						);
					})
				}
				);
				// let wasDismissed: boolean = false;
				// const popover = this.popoverCtrl.create(page, data, {
				//   showBackdrop: false,
				//   cssClass: 'standard-popover'
				// });
				// popover.present();

			}
		})


	}

	private addShowPlayerDashboard() {
		this._Que.push({
			name: "Check Player Dashboard",
			action: () => {
				this.navigator.navigateTo("PlayerDashboardComponent", { multipleModals: true }, { callBackFn: () => { this._Que.pop(); this.next(); } });
			}
		});
	}
}
